module.exports = __webpack_public_path__ + "static/media/disease.a2cb14e0.svg";